import { render, staticRenderFns } from "./officer-recipients-add.vue?vue&type=template&id=2bc72063"
import script from "./officer-recipients-add.vue?vue&type=script&lang=js"
export * from "./officer-recipients-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports